// Mock data for testing admit card feature
// Remove this file once the backend API is ready

export const mockAdmitCardData = {
    success: true,
    statusCode: 200,
    data: [
        {
            _id: "67a0e1b2c3d4e5f6g7h8i9j0",
            serialNumber: "75001",
            rollNumber: "PS/2024/001",
            student: {
                _id: "60d5ecb71f29a83064e52123",
                firstName: "Arjun",
                lastName: "Sharma",
                profilePicture: "https://api.dicebear.com/7.x/avataaars/svg?seed=Arjun"
            },
            class: {
                _id: "60d5ecb71f29a83064e52456",
                name: "Class 10"
            },
            examType: {
                _id: "60d5ecb71f29a83064e52789",
                name: "Final Environment Examination"
            },
            academicSession: {
                _id: "60d5ecb71f29a83064e52000",
                label: "2024-25"
            },
            examRoutine: [
                {
                    subjectName: "Mathematics",
                    subjectCode: "MATH101",
                    examDate: "2024-03-15T00:00:00.000Z",
                    startTime: "10:00 AM",
                    endTime: "01:00 PM",
                    room: "Room 102",
                    _id: "67a0e1b2c3d4e5f6g7h8i9j1"
                },
                {
                    subjectName: "Science",
                    subjectCode: "SCI101",
                    examDate: "2024-03-17T00:00:00.000Z",
                    startTime: "10:00 AM",
                    endTime: "01:00 PM",
                    room: "Lab A",
                    _id: "67a0e1b2c3d4e5f6g7h8i9j2"
                },
                {
                    subjectName: "English",
                    subjectCode: "ENG101",
                    examDate: "2024-03-20T00:00:00.000Z",
                    startTime: "10:00 AM",
                    endTime: "01:00 PM",
                    room: "Room 105",
                    _id: "67a0e1b2c3d4e5f6g7h8i9j3"
                },
                {
                    subjectName: "Social Studies",
                    subjectCode: "SS101",
                    examDate: "2024-03-22T00:00:00.000Z",
                    startTime: "10:00 AM",
                    endTime: "01:00 PM",
                    room: "Room 103",
                    _id: "67a0e1b2c3d4e5f6g7h8i9j4"
                },
                {
                    subjectName: "Hindi",
                    subjectCode: "HIN101",
                    examDate: "2024-03-25T00:00:00.000Z",
                    startTime: "10:00 AM",
                    endTime: "01:00 PM",
                    room: "Room 104",
                    _id: "67a0e1b2c3d4e5f6g7h8i9j5"
                }
            ],
            isBlocked: false,
            blockReason: "",
            createdAt: "2024-02-03T11:20:45.123Z",
            updatedAt: "2024-02-03T11:20:45.123Z"
        }
    ],
    message: "Student admit cards fetched successfully"
};
